import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '../components/MarketingPage.js'
import { Icon, type IconName } from '../components/Icon.js'

export const Route = createFileRoute('/contact')({
  component: ContactPage,
})

const CONTACT_METHODS: {
  icon: IconName
  label: string
  value: string
  href: string
  hint: string
}[] = [
  {
    icon: 'inbox',
    label: 'Email',
    value: 'hello@brightstars.in',
    href: 'mailto:hello@brightstars.in',
    hint: 'For sales, support, billing, and partnership enquiries. We reply within one business day.',
  },
  {
    icon: 'wallet',
    label: 'Phone',
    value: '+91 98493 76464',
    href: 'tel:+919849376464',
    hint: 'Monday to Saturday, 10:00 to 19:00 IST. Closed on national holidays.',
  },
  {
    icon: 'settings',
    label: 'Registered office',
    value: 'C 506, SBSV Avatar Apartments, RC Puram, Hyderabad, Telangana 502032, India',
    href: '',
    hint: 'Visit by appointment only. For postal correspondence, please email us first so we can route your request to the right team.',
  },
]

function ContactPage() {
  return (
    <MarketingPage
      eyebrow="Contact us"
      title="We&rsquo;d love to hear from you."
    >
      <p>
        Whether you are evaluating Brightstars for your academy, have a billing
        question, or want help getting set up, here are the fastest ways to
        reach us.
      </p>

      <div className="not-prose mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {CONTACT_METHODS.map((method) => (
          <div
            key={method.label}
            className="rounded-xl border border-border bg-surface p-5 shadow-sm"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-[var(--color-primary-tint)] text-[var(--color-primary)]">
                <Icon name={method.icon} size={16} />
              </span>
              <span className="text-xs font-medium uppercase tracking-wider text-fg-subtle">
                {method.label}
              </span>
            </div>
            {method.href ? (
              <a
                href={method.href}
                className="mt-3 block text-base font-semibold text-fg hover:text-[var(--color-primary)] transition-colors"
              >
                {method.value}
              </a>
            ) : (
              <p className="mt-3 text-base font-semibold text-fg">
                {method.value}
              </p>
            )}
            <p className="mt-2 text-sm text-fg-muted leading-relaxed">
              {method.hint}
            </p>
          </div>
        ))}
      </div>

      <h2>Support hours</h2>
      <p>
        Standard support is available Monday to Saturday, 10:00 to 19:00 IST.
        Emails sent outside these hours are answered the next working day.
        Critical payment or login issues are addressed as quickly as possible,
        including after-hours where feasible.
      </p>

      <h2>Grievance officer</h2>
      <p>
        In accordance with the Information Technology Act, 2000 and the
        Information Technology (Intermediary Guidelines and Digital Media
        Ethics Code) Rules, 2021, our grievance officer can be reached at{' '}
        <a href="mailto:grievance@brightstars.in">grievance@brightstars.in</a>.
        We acknowledge complaints within 24 hours and aim to resolve them
        within 15 days.
      </p>

      <h2>Business hours</h2>
      <p>
        Our team is based in India and operates on IST (UTC + 5:30).
      </p>
    </MarketingPage>
  )
}
